import { PodSchedulingValues } from '../../pod-scheduling-rules/usePodSchedulingRulesStore';
import { AffinityItem, YamlAffinityItem } from '../../types';

const { DEFAULT, AGGREGATION, DECENTRALIZED } = PodSchedulingValues;

/** 调度转 yaml */
export const schedulingToYaml = (
  scheduling: PodSchedulingValues,
  matchLabels: Record<string, string>,
): YamlAffinityItem => {
  const affinityItem: AffinityItem = {
    weight: 1,
    podAffinityTerm: {
      labelSelector: {
        matchLabels,
      },
      topologyKey: 'kubernetes.io/hostname',
    },
  };

  switch (scheduling) {
    case DECENTRALIZED:
      return {
        podAntiAffinity: {
          preferredDuringSchedulingIgnoredDuringExecution: [affinityItem],
        },
      };
    case AGGREGATION:
      return {
        podAffinity: {
          preferredDuringSchedulingIgnoredDuringExecution: [affinityItem],
        },
      };
    case DEFAULT:
    default:
      return undefined;
  }
};

/**
 * yaml 转调度
 * 预留: 未来可能会有自定义策略,比较复杂,暂时只有默认、集中、分散
 */
export const yamlToScheduling = (item: YamlAffinityItem): PodSchedulingValues => {
  if (item?.podAntiAffinity) {
    return PodSchedulingValues.DECENTRALIZED;
  }
  if (item?.podAffinity) {
    return PodSchedulingValues.AGGREGATION;
  }
  return PodSchedulingValues.DEFAULT;
};
